
import { PUBLIC_MENU_CONFIG } from './menuConfigs';
import LayoutBase from './LayoutBase';
import './layout.css';
import './layoutPublic.css';

export const LayoutPublic = () => (
  <LayoutBase
    menuConfig={PUBLIC_MENU_CONFIG}
    navClass="niogems-layout-nav niogems-layout-nav-public"
  />
);

export default LayoutPublic;